import React from "react";

import Cookies from "js-cookie";
import Modal from "react-bootstrap/Modal";

import { PALETTE } from "../../common/ThemeConstants";
import { postRequest } from "../../api/axiosRequests";

export default function SkillsModal(props) {
  const updateUserExerciseFavouriteValue = (id, checked) => {
    let newExercise = props.exercises[id];
    newExercise.favourite = checked;
    const data = newExercise;
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const promise = postRequest("updateUserExerciseMaximum/", data, headers);
    promise.then((res) => {
      props.onSubmit();
    });
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ borderBottom: "none" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Modifica preferenze
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "scroll", paddingTop: 0 }}>
        <p style={{ color: PALETTE.DARKGRAY, fontSize: 14, marginBottom: 24 }}>
          Seleziona le skills che vuoi visualizzare nella schermata principale
        </p>
        {props.exercises.length > 0 && (
          <div>
            {props.exercises.map((exercise, idx) => (
              <div
                key={idx}
                className="mb-2 rounded-md"
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "10px 15px",
                  cursor: "pointer",
                  backgroundColor: exercise.favourite ? PALETTE.LIGHTGRAY : PALETTE.WHITE,
                  color: exercise.favourite ? PALETTE.DARKGRAY : PALETTE.DARKGRAY,
                  transition: "all 0.3s ease",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
                onClick={() => updateUserExerciseFavouriteValue(idx, !exercise.favourite)}
              >
                <span style={{ fontWeight: exercise.favourite ? "500" : "400" }}>
                  {exercise.name}
                </span>
                <div style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: exercise.favourite ? PALETTE.WHITE : PALETTE.WHITE,
                  border: `2px solid ${exercise.favourite ? "#ffffff" : PALETTE.TRUEGRAY}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  {exercise.favourite && (
                    <div style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: PALETTE.MAINCOLOR
                    }} />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {props.exercises.length == 0 && (
          <p style={{ color: PALETTE.DARKGRAY, fontSize: 20 }}>
            Nessuna skill trovata
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
}
